module.exports = __webpack_public_path__ + "static/img/gaozhongdili10.e71954fc.jpg";